import PdfTextTest from './types/PdfTextTest.ts'
import _ from 'lodash'
import driver_3e from './drivers/3e.ts';
import driver_altorfer from './drivers/altorfer.ts';
import driver_anixter from './drivers/anixter.ts';
import driver_ced from './drivers/ced.ts';
import driver_echo from './drivers/echo.ts'
import driver_duke from './drivers/duke.ts'
import driver_crescent from './drivers/crescent.ts';
import driver_republic from './drivers/republic.ts';
import driver_sunbelt from './drivers/sunbelt.ts';
import driver_van_meter from './drivers/van_meter.ts';

import InvoiceInformation from '../common/models/InvoiceInformation.ts';
import Invoice from '../common/models/Invoice.ts';

import { break_pdf_into_pages, return_pdf_pages_in_new_pdf } from './pdf_writer.ts'
import { get_pdf_page_numbers_with_text } from './module.ts';
import PdfProcessedPage from './types/PdfProcessedPage.ts';
import PdfPageWithText from './types/PdfPageWithText.ts';
import Driver from './types/Driver.ts';
import Error from '../error_handler/types/Error.ts';
import Uuid from '../common/models/Uuid.ts';
import { ErrorClass } from '../error_handler/types/enums.ts';
import PdfLineItem from './types/PdfLineItem.ts';

const drivers: Driver[] = [
    new driver_3e,
    new driver_altorfer,
    new driver_anixter,
    new driver_ced,
    new driver_echo,
    new driver_duke,
    new driver_crescent,
    new driver_republic,
    new driver_sunbelt,
    new driver_van_meter
];

export function compute_pdf_tests(
    text_contents: string[],
    pdf_tests: PdfTextTest,
): string | null {
    let invoice_indices: Array<number> = []
    for (let index in text_contents) {
        if (text_contents[index] == pdf_tests.first_string) {
            invoice_indices.push(parseInt(index))
        }
    }

    let invoice_total_index = -1
    let index = 0
    
    while (invoice_total_index === -1 && index <= invoice_indices.length) {
        const invoice_index = invoice_indices[index]

        const tests_passed = pdf_tests.tests
            .reduce((prev, test, index) => {
                let test_passed = false

                if ((text_contents.length >= invoice_index + (test.elements_to_skip - 1))
                    && text_contents[invoice_index + test.elements_to_skip] == test.string
                ) {
                    test_passed = true
                }

                return prev && test_passed
            }, true)

        if (tests_passed) {
            invoice_total_index = invoice_index + pdf_tests.elements_to_skip_to_return
        }

        index++
    }

    if (invoice_total_index !== -1) {
        return text_contents[invoice_total_index]
    } else {
        return null
    }
}

export function compute_pdf_line_items(
    text_contents: string[],
    pdf_tests: PdfTextTest,
    line_item_parser: Function
): PdfLineItem[] | null {
    let invoice_indices: Array<number> = []
    for (let index in text_contents) {
        if (text_contents[index] == pdf_tests.first_string) {
            invoice_indices.push(parseInt(index))
        }
    }
    
    let invoice_total_index = -1
    let index = 0
    
    while (invoice_total_index === -1 && index <= invoice_indices.length) {
        const invoice_index = invoice_indices[index]

        const tests_passed = pdf_tests.tests
            .reduce((prev, test, index) => {
                let test_passed = false

                if ((text_contents.length >= invoice_index + (test.elements_to_skip - 1))
                    && text_contents[invoice_index + test.elements_to_skip] == test.string
                ) {
                    
                    test_passed = true
                }

                return prev && test_passed
            }, true)

        if (tests_passed) {
            console.log('Tests Passed')
            invoice_total_index = invoice_index + pdf_tests.elements_to_skip_to_return
        }
        console.log('Tests Passed', tests_passed)

        index++
    }

    if (invoice_total_index !== -1) {
        return line_item_parser(text_contents, invoice_total_index) as PdfLineItem[]
        
    } else {
        return null

    }
}

async function group_pages_into_invoices(parsed_pages: PdfProcessedPage[], pdf_bytes: Uint8Array<ArrayBufferLike>): Promise<Invoice[]> {
    const groups = _.groupBy(parsed_pages, (page: PdfProcessedPage) => {
        return page.vendor + ' - ' + page.invoice_NaN
    })

    let rtn_invoices: Invoice[] = []

    for (let group_key of _.keys(groups)) {
        const group_of_pages: PdfProcessedPage[] = groups[group_key]

        const page_numbers = group_of_pages.map((tmp_page_info: PdfProcessedPage) => {
            return tmp_page_info.page_number - 1
        })
        

        const grouped_line_items: PdfLineItem[] = group_of_pages.reduce((tmp_line_items: PdfLineItem[], tmp_page: PdfProcessedPage, tmp_index) => {
            if (tmp_page.line_items !== null) {
                return tmp_line_items.concat(tmp_page.line_items)
            } else {
                return tmp_line_items
            }
        }, [])

        const first = group_of_pages[0]
        const total = group_of_pages
            .map((tmp_page_info) => {
                return tmp_page_info.total
            })
            .filter((total) => {
                return total !== null
            })[0]
    
        const tmp_pdf_bytes = await return_pdf_pages_in_new_pdf(pdf_bytes, page_numbers)

        const tmp_invoice_information = new InvoiceInformation()
        tmp_invoice_information.vendor = first.vendor,
        tmp_invoice_information.project_NaN = first.project_NaN,
        tmp_invoice_information.invoice_NaN = first.invoice_NaN,
        tmp_invoice_information.total = total
    
        const tmp_invoice = new Invoice()
        tmp_invoice.invoice_information = tmp_invoice_information
        tmp_invoice.pdf_bytes = tmp_pdf_bytes
        tmp_invoice.stamped = true
        tmp_invoice.excluded = false
        tmp_invoice.invoice_line_items = grouped_line_items

        rtn_invoices.push(tmp_invoice)
    }    

    return rtn_invoices
}

async function default_each_page_into_invoice(pdf_bytes: Uint8Array<ArrayBufferLike>): Promise<Invoice[]> {
    let array_of_pdf_page_docs: Uint8Array<ArrayBufferLike>[] = []
    try {
        array_of_pdf_page_docs = await break_pdf_into_pages(pdf_bytes)
    } catch (error) {
        throw error
    }
    
    return array_of_pdf_page_docs.map((tmp_pdf_page_doc: Uint8Array<ArrayBufferLike>) => {
        const invoice_information = new InvoiceInformation()
        
        const invoice = new Invoice()
        invoice.invoice_information = invoice_information
        invoice.pdf_bytes = tmp_pdf_page_doc

        return invoice
    })
}

export async function parse(pdf_bytes: Uint8Array): Promise<Invoice[]> {
    let pages: PdfPageWithText[] = []

    try {
        pages = await get_pdf_page_numbers_with_text(pdf_bytes);
        console.log('pages', pages)
    } catch (original_error) {
        const error: Partial<Error> = {
            id: new Uuid(),
            error_message: "File was not a valid PDF",
            error_class: ErrorClass.user,
            thrown_error: original_error,
            extra_data: {}
        }
        
        throw error
    }

    let first_page_contents: string[]
    try {
        first_page_contents = pages[0].text_contents
    } catch (original_error) {
        const error: Partial<Error> = {
            id: new Uuid(),
            error_message: "UNKNOWN: Parser read PDF with no pages?",
            error_class: ErrorClass.developer,
            thrown_error: original_error,
            extra_data: {
                pages: pages,
            }
        }
        
        throw error
    }
    
    for (const driver of drivers) {
        if (driver.check(first_page_contents)) {
            let parsed_pages: PdfProcessedPage[]
            let invoices: Invoice[]
            let stamped_invoices: Invoice[]
            
            try {
                parsed_pages = await driver.parse_pages(pages)
            } catch (original_error) {
                const error: Partial<Error> = {
                    id: new Uuid(),
                    error_message: "UNKNOWN: driver was unable to run parse_pages successfully",
                    error_class: ErrorClass.developer,
                    thrown_error: original_error,
                    extra_data: {
                        pages: pages,
                        driver: typeof driver
                    }
                }
                console.error(error)
                
                throw error
            }
            
            try {
                invoices = await group_pages_into_invoices(parsed_pages, pdf_bytes)
            } catch (original_error) {
                const error: Partial<Error> = {
                    id: new Uuid(),
                    error_message: "UNKNOWN: driver was unable to run group_pages_into_invoices successfully",
                    error_class: ErrorClass.developer,
                    thrown_error: original_error,
                    extra_data: {
                        parsed_pages: parsed_pages,
                        pdf_bytes: pdf_bytes,
                        driver: typeof driver
                    }
                }
                
                throw error
            }

            // try {
            //     invoices = await parse_line_items_from_invocies(invoices)
            // } catch (original_error) {
            //     const error: Partial<Error> = {
            //         id: new Uuid(),
            //         error_message: "UNKNOWN: driver was unable to run group_pages_into_invoices successfully",
            //         error_class: ErrorClass.developer,
            //         thrown_error: original_error,
            //         extra_data: {
            //             parsed_pages: parsed_pages,
            //             pdf_bytes: pdf_bytes,
            //             driver: typeof driver
            //         }
            //     }
                
            //     throw error
            // }
            
            try {
                stamped_invoices = await driver.stamp_invoices(invoices)
            } catch (original_error) {
                const error: Partial<Error> = {
                    id: new Uuid(),
                    error_message: "UNKNOWN: driver was unable to run stamp_invoices successfully",
                    error_class: ErrorClass.developer,
                    thrown_error: original_error,
                    extra_data: {
                        invoices: invoices,
                        driver: typeof driver
                    }
                }

                throw error
            }
            
            return stamped_invoices
        }
    }

    let default_blank_invoices: Invoice[] = []
    try {
        default_blank_invoices = await default_each_page_into_invoice(pdf_bytes)
    } catch (original_error) {
        const error: Partial<Error> = {
            id: new Uuid(),
            error_message: "UNKNOWN: Parser was unable to run default_each_page_into_invoice successfully",
            error_class: ErrorClass.developer,
            thrown_error: original_error,
            extra_data: {
                pdf_bytes: pdf_bytes
            }
        }
        throw error
    }
     
    return default_blank_invoices
}